import { ROUTE_QUESTIONNAIRE } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './questionnaire.page';

export const routeQuestionnaire: RouteObject = {
  path: ROUTE_QUESTIONNAIRE,
  Component: Page,
  loader: setTitleFromLoader('Risk Assessment'),
};
